import Home from './components/home/Home.vue';

import Router  from 'vue-router';

export const router = new Router({ 
    routes:[
      {path:'/',name:'home', component:Home}
    ],
    mode:'history',
    base:`${process.env.VUE_APP_BASE_ROUTE}`
  });
  